import { Box } from "@mui/material";
import { useCallback } from "react";

import ManagementAlertsSection from "../ManagementAlertsSection";
import OperationalReadinessSection from "../OperationalReadinessSection";
import ManagementActionCenter from "../components/ManagementActionCenter";
import RequestRiskPreviewPanel from "../components/RequestRiskPreviewPanel";
import SlaPerformanceSection from "../components/SlaPerformanceSection";

const ControlCenterTab = ({
  alertsLoading,
  alertsError,
  alertsData,
  readinessLoading,
  readinessError,
  readinessData,
  actionCenterLoading,
  actionCenterError,
  actionCenterData,
  workflowLoading,
  workflowError,
  workflowData,
  workflowSyncing,
  slaLoading,
  slaError,
  slaData,
  riskLoading,
  riskError,
  riskData,
  dashboardFilters,
  loadAlerts,
  loadReadiness,
  loadActionCenter,
  loadWorkflowActions,
  syncWorkflowActions,
  updateWorkflowAction,
  loadSlaPerformance,
  loadRequestRiskPredictions,
  dashboardAccess,
}) => {
  const handleUpdateAction = useCallback(
    (payload) => updateWorkflowAction(payload, dashboardFilters),
    [updateWorkflowAction, dashboardFilters]
  );

  return (
    <Box>
      <ManagementActionCenter
        loading={actionCenterLoading}
        error={actionCenterError || workflowError}
        suggestionsData={actionCenterData}
        workflowData={workflowData}
        workflowLoading={workflowLoading}
        dashboardFilters={dashboardFilters}
        dashboardAccess={dashboardAccess}
        syncing={workflowSyncing}
        onRetry={() => {
          loadActionCenter(dashboardFilters);
          loadWorkflowActions(dashboardFilters);
        }}
        onSync={syncWorkflowActions}
        onUpdateAction={handleUpdateAction}
      />

      <ManagementAlertsSection
        loading={alertsLoading}
        error={alertsError}
        data={alertsData}
        onRetry={() => loadAlerts(dashboardFilters)}
      />

      <OperationalReadinessSection
        loading={readinessLoading}
        error={readinessError}
        data={readinessData}
        onRetry={() => loadReadiness(dashboardFilters)}
      />

      <SlaPerformanceSection
        loading={slaLoading}
        error={slaError}
        data={slaData}
        onRetry={() => loadSlaPerformance(dashboardFilters)}
      />

      <RequestRiskPreviewPanel
        loading={riskLoading}
        error={riskError}
        data={riskData}
        onRetry={() => loadRequestRiskPredictions(dashboardFilters)}
      />
    </Box>
  );
};

export default ControlCenterTab;
